module.exports = __webpack_public_path__ + "img/四川天府新区华阳飞翔幼儿园.6a8269ac.jpg";